<template>
  <div class="tw-flex tw-min-w-0 tw-items-start tw-text-gray">
    <div 
      v-if="props.showIcon" 
      class="tw-mr-3">
      <QIcon name="sell" />
    </div>
    <div class="tw-flex tw-min-w-0 tw-flex-wrap">
      <NuxtLink
        v-for="(item, index) in props.items"
        :key="`tag-${index}`"
        :to="getPath({ componentName: 'Article', tagSlug: getTagSlug(item) })"
        :title="getTagTitle(item)"
        class="tw-mr-3 tw-max-w-full tw-text-dt-body hover:tw-text-primary-500 tw-transition-colors"
      >
        <span v-if="showSignInTag">#</span>
        <span 
          v-if="showCustomStyleTag" 
          class="tw-break-words"
          @click="eventTag(item)">
          {{ getTagTitle(item) }}
        </span>
        <span 
          v-if="!showCustomStyleTag" 
          class="tw-break-words"
          @click="eventTag(item)"
          >#{{ getTagTitle(item) }}</span
        >
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { normalizeTagValue } from '~/utils/route'

type TagItem = string | {
  title: string
  slug?: string
}

const props = defineProps({
  items: {
    type: Array as PropType<TagItem[]>,
    default: () => [],
    required: true,
  },
  categoryEventName: {
    type: String,
    default: "",
  },
  eventName: {
    type: String,
    default: "",
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
  showCustomStyleTag: {
    type: Boolean,
    default: false,
  },
  showSignInTag: {
    type: Boolean,
    default: false,
  },
});

const { getPath } = useNavigationMenu();
const getTagTitle = (value: TagItem) =>
  normalizeTagValue(typeof value === 'string' ? value : value.title)

const getTagSlug = (value: TagItem) =>
  normalizeTagValue(typeof value === 'string' ? value : value.slug || value.title)

const { analyticEvent } = useAnalytic();
const eventTag = (value: TagItem) => {
  analyticEvent({
    ga4ActionName: props.eventName,
    ga4Label: getTagTitle(value),
  });
};
</script>
